import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"
import ContactForm from "../components/contactForm"
import { Table, TableHeader, TableBody, TableRow, TableCell } from "grommet"
import {
  INDIVIDUAL_THERAPY_FEE,
  RELATIONSHIPS_THERAPY_FEE,
  PATERNITY_THERAPY_FEE,
  SESSION_DURATION
} from "../utils/constants"
import contactStyles from "./contact.module.scss"
import bookASessionStyles from "./book-a-session.module.scss"
import aboutMeStyles from "../pages/about-me.module.scss"
import {
  INDIVIDUAL_THERAPY_NAME,
  RELATIONSHIPS_THERAPY_NAME,
  PATERNITY_FATHERHOOD_COACHING_NAME
} from "../data/whatIOfferData"
import { getLinkByPageKey, pageKeys } from "../utils/navHelper"

const BookASessionPage = () => {
  return (
    <Layout isHome={false}>
      <Head
        title="Book A Session"
        description={`Set up a session for ${INDIVIDUAL_THERAPY_NAME}, ${RELATIONSHIPS_THERAPY_NAME}, or ${PATERNITY_FATHERHOOD_COACHING_NAME}`}
      />
      <h2>Book A Session</h2>
      <p>
        If you're interested in working together, you'll find the different
        session formats and fees below. All sessions take place online.
      </p>
      <section aria-labelledby="session-table-heading">
        <h3 className={aboutMeStyles.subtitle} id="session-table-heading">
          Session Types, Durations & Fees
        </h3>
        <div className={bookASessionStyles.sessionTableWrap}>
          <Table
            className={`${bookASessionStyles.sessionTable} ${bookASessionStyles.header}`}
            aria-labelledby="session-table-heading"
          >
            <TableHeader>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Fee</TableCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>
                  {getLinkByPageKey(
                    pageKeys.WHAT_I_OFFER,
                    false,
                    INDIVIDUAL_THERAPY_NAME,
                    { openSectionIndex: 0 }
                  )}
                </TableCell>
                <TableCell>{SESSION_DURATION}</TableCell>
                <TableCell>{INDIVIDUAL_THERAPY_FEE}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  {getLinkByPageKey(
                    pageKeys.WHAT_I_OFFER,
                    false,
                    PATERNITY_FATHERHOOD_COACHING_NAME,
                    { openSectionIndex: 2 }
                  )}
                </TableCell>
                <TableCell>{SESSION_DURATION}</TableCell>
                <TableCell>{PATERNITY_THERAPY_FEE}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  {getLinkByPageKey(
                    pageKeys.WHAT_I_OFFER,
                    false,
                    RELATIONSHIPS_THERAPY_NAME,
                    { openSectionIndex: 1 }
                  )}
                </TableCell>
                <TableCell>{SESSION_DURATION}</TableCell>
                <TableCell>{RELATIONSHIPS_THERAPY_FEE}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <p>
            Longer sessions:
            <br />
            Sometimes, due to the nature of the work, couples and coaching
            clients can benefit from longer sessions. If you feel it would
            support your process, 90-minute sessions can be arranged on request.
          </p>
        </div>
      </section>
      <h3 className={aboutMeStyles.subtitle}>
        Arrange a Free Introductory Call
      </h3>
      <p>
        I offer a free, confidential introductory call to help you get a sense
        of whether we're a good fit and to answer any initial questions you may
        have.
      </p>
      <h4>For individuals and coaching clients:</h4>
      <ul>
        {" "}
        <li>15-minute intro call</li>
      </ul>
      <h4>For couples:</h4>
      <ul>
        {" "}
        <li style={{ marginBottom: "0px" }}>30-minute intro call</li>
        <p>
          Working with two people means we're forming a three-way therapeutic
          relationship. This longer introductory call gives us space to meet
          together, discuss what brings you here, and ensure we can all create a
          safe and supportive environment for the work ahead.
        </p>
      </ul>
      <h3 className={aboutMeStyles.subtitle}>
        How to Book Your Intro Call or Ask a Question
      </h3>
      <p>
        If you have questions not covered in the{" "}
        {getLinkByPageKey(pageKeys.FAQ, false)} or want to arrange a free
        introductory call, you can contact me in either of the following ways:
      </p>
      <div className={contactStyles.infoContainer}>
        <ul>
          <li>
            Email:{" "}
            <a href="mailto:hello@gavinlashleytherapy.com">
              hello@gavinlashleytherapy.com
            </a>
          </li>
          <li>Use the contact form below</li>
        </ul>
        <p>
          You don't need to have all the right words — even a brief message is
          enough to begin the conversation.
        </p>
        <p>
          I aim to reply to emails and form submissions within two working days.
        </p>
      </div>

      <div className={contactStyles.formContainer}>
        <ContactForm />
      </div>
      <img
        className={`${bookASessionStyles.smallIntroImage}`}
        src="/gavin_lashley_therapy_portrait_rz2.jpg"
        alt="Gavin Lashley portrait"
      />
    </Layout>
  )
}

export default BookASessionPage
